import React from 'react';
import { ShieldCheck } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function PricingSection() {
  return <section id="pricing" className="py-20 md:py-24 px-4 sm:px-6 relative" data-id="element-202">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-gold/5 via-dark-bg to-dark-bg pointer-events-none" data-id="element-203"></div>

      <div className="max-w-md mx-auto relative z-10" data-id="element-204">
        <div className="bg-[#151820] border border-gold/30 rounded-2xl p-6 md:p-10 shadow-[0_0_50px_rgba(201,168,76,0.1)] text-center" data-id="element-205">
          <h2 className="text-2xl font-playfair font-bold text-text-primary mb-2" data-id="element-206">
            Instant Access
          </h2>
          <p className="text-text-secondary mb-8" data-id="element-207">Complete 14-Day Protocol</p>

          <div className="flex justify-center items-center gap-4 mb-8" data-id="element-208">
            <span className="text-2xl text-gray-500 line-through decoration-red-500/50" data-id="element-209">
              $34
            </span>
            <span className="text-5xl md:text-6xl font-bold text-white" data-id="element-210">
              $6.39
            </span>
          </div>

          <ul className="text-text-secondary space-y-2 mb-8 text-base" data-id="element-211">
            <li data-id="element-212">✓ Instant download</li>
            <li data-id="element-213">✓ Private PDF format</li>
            <li data-id="element-214">✓ Lifetime access</li>
          </ul>

          <a href="https://salunza.com/cart/44204988465287:1" target="_blank" rel="noopener noreferrer" onClick={trackAddToCart} className="block w-full bg-gold hover:bg-gold-hover text-dark-bg font-bold text-lg py-4 px-6 rounded-xl shadow-[0_0_20px_rgba(201,168,76,0.3)] transition-all hover:shadow-[0_0_30px_rgba(201,168,76,0.5)] hover:-translate-y-1 mb-5 cursor-pointer" data-id="element-215">
            GET MY COPY — $6.39
          </a>

          <div className="bg-dark-bg border border-dark-border rounded-xl p-6 text-left flex gap-4 items-start" data-id="element-216">
            <ShieldCheck className="w-8 h-8 text-gold shrink-0" data-id="element-217" />
            <div data-id="element-218">
              <h4 className="font-bold text-text-primary mb-2" data-id="element-219">
                7-DAY GUARANTEE
              </h4>
              <p className="text-sm text-text-secondary leading-relaxed" data-id="element-220">
                Try it risk-free. If it's not for you, we'll refund every penny.
                No questions asked. No complicated forms. No pressure.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}